import Accordion from 'entities/Accordion'
import { CheckBox } from 'entities/ChekBox'
import { getAppName } from 'shared/helpers/getAppName'
import { useConfigStore } from 'shared/store/configSlice'
import { useGlobalStore } from 'shared/store/globalSlice'
import { ResetCacheHandler } from 'features/_Buttons/ResetCache'
import { RenderIf } from 'shared/helpers/renderIf'
import { ResetMWLock } from '../../../features/_Buttons/ResetMWLock'

export const ExtraOptionsAccordion = () => {
  const isCC = useGlobalStore().isCCSelected
  const menuConfig = useConfigStore().config?.menuConfig
  const interfaceConfig = useConfigStore().config?.interfaceConfig

  const updateMenuConfig = useConfigStore().updateMenuConfig
  const updateInterface = useConfigStore().updateInterface

  const handleUpdateLogin = (value: boolean) => {
    updateMenuConfig({ loginAvailable: value })
  }

  const handleUpdateReservation = (value: boolean) => {
    updateMenuConfig({ isReservationsShown: value ? 1 : 0 })
  }

  const handleSocials = (value: boolean) => {
    updateMenuConfig({ isSocialsShown: value ? 1 : 0 })
  }

  const handleWaiterCall = (value: boolean) => {
    updateInterface({ waiterCall: value })
  }

  return (
    <Accordion title='Extra'>
      <br />
      <ResetMWLock />
      <CheckBox
        checked={Boolean(menuConfig?.[getAppName(isCC)]?.loginAvailable)}
        handleChange={handleUpdateLogin}
        label='Allow login'
      />
      <CheckBox
        checked={Boolean(menuConfig?.[getAppName(isCC)]?.isReservationsShown)}
        handleChange={handleUpdateReservation}
        label='Show reservation'
      />
      <CheckBox
        checked={Boolean(menuConfig?.[getAppName(isCC)]?.isSocialsShown)}
        handleChange={handleSocials}
        label='Show socials'
      />
      <RenderIf condition={!isCC}>
        <CheckBox
          checked={Boolean(interfaceConfig?.[getAppName(isCC)]?.waiterCall)}
          handleChange={handleWaiterCall}
          label='Waiter Call'
        />
      </RenderIf>
      <ResetCacheHandler />
    </Accordion>
  )
}
